<div class="filter-item d-flex justify-content-between">
    <label class="label text-end">Reaction</label>
    <div class="btn-group w-200px" role="group" aria-label="Filter By Reactions">
        <button class="btn btn-danger btn-just-icon" [ngClass]="{'active': type.checked}"
            *ngFor="let type of reactionTypes" (click)="toogleReactions(type)"
            [title]="type.reaction">
            <i class="{{type.icon}}"> </i>
        </button>
    </div>
</div>